import * as React from "react"
import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "filled" | "outlined"
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "filled", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full text-sm transition-all",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "placeholder:text-muted-foreground/60",
          "focus-visible:outline-none",
          "disabled:cursor-not-allowed disabled:opacity-50",
          variant === "filled" && [
            "bg-muted/50 border-0 border-b-2 border-border rounded-t-lg rounded-b-none",
            "px-4 pt-4 pb-2",
            "hover:bg-muted/70",
            "focus:bg-muted/70 focus:border-b-primary",
          ],
          variant === "outlined" && [
            "bg-transparent border border-border rounded-lg",
            "px-4 py-3",
            "hover:border-primary/50",
            "focus:border-primary focus:ring-2 focus:ring-primary/20",
          ],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
